var _path, _path2, _circle, _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoctorList(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1786 1.5H11.625H12.3595C13.7446 1.5 14.8008 2.73949 14.581 4.10703L13.3757 11.607C13.2003 12.6979 12.259 13.5 11.1542 13.5H5.34584C4.24101 13.5 3.29965 12.6979 3.12434 11.607L1.91899 4.10702C1.6992 2.73949 2.75539 1.5 4.14048 1.5H4.875H6.32143",
    stroke: "#3C3C3C",
    strokeWidth: 1.125,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.06067 13.7647V19.125C8.06067 20.989 9.57171 22.5 11.4357 22.5H16.1249C17.9889 22.5 19.4999 20.989 19.4999 19.125V9",
    stroke: "#3C3C3C",
    strokeWidth: 1.125
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 7.5,
    r: 2.4375,
    stroke: "#3C3C3C",
    strokeWidth: 1.125
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.28162,
    y: 0.357422,
    width: 2.13423,
    height: 2.25,
    rx: 1.06712,
    fill: "#3C3C3C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.10095,
    y: 0.357422,
    width: 2.13423,
    height: 2.25,
    rx: 1.06712,
    fill: "#3C3C3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctorList);
export default __webpack_public_path__ + "static/media/doctor-list.503e5319ef39bae535d4617064268e13.svg";
export { ForwardRef as ReactComponent };